import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import PaymentReturn from "@/pages/PaymentReturn";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/pago" element={<PaymentReturn />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            border: "3px solid #000",
            borderRadius: 0,
            boxShadow: "4px 4px 0 0 #000",
            fontFamily: "Outfit, sans-serif",
            fontWeight: 600,
            background: "#FFD100",
            color: "#000",
          },
        }}
      />
    </div>
  );
}

export default App;
